module.exports = __webpack_public_path__ + "media/images/Delete-blue-61e8a0f5a996b0ca37742cee5f151b44.svg";